import React, { useEffect, useState } from "react";
import { apiFetch } from '../utils/apiClient'; // ✅ import your reusable fetch hel

const ReassignerGroup = ({ onUserSelect, nomFormulaire }) => {
    const [roles, setRoles] = useState([]);
    // const [loading, setLoading] = useState(true);
    // const [error, setError] = useState(null);
    const [selectedUser, setSelectedUser] = useState("");

    useEffect(() => {
        const fetchRoles = async () => {
            try {
              const response = await apiFetch(`${process.env.REACT_APP_API_BASE_URL}/getUsers?nomFormulaire=${nomFormulaire}`);
              if (!response.ok) throw new Error("Failed to fetch roles");
              const data = await response.json();
              setRoles(data);
            } catch (err) {
              console.log(err.message);
            } finally {
              // setLoading(false);
            }
          };
    
        // Initial fetch when the component mounts
        fetchRoles();
    
        // // Set an interval to keep calling the fetchRoles function every 5 seconds
        // const intervalId = setInterval(fetchRoles, 5000);  // Call every 5 seconds (5000ms)
    
        // // Cleanup the interval on component unmount
        // return () => clearInterval(intervalId);
    
      }, [nomFormulaire]); 

       
        const handleChange = (event) => {
            const userId = event.target.value;
            setSelectedUser(userId);
            const user = roles.find((role) => role.userId === userId);
            if (onUserSelect) {
              onUserSelect(user); // Transmettre l'utilisateur sélectionné au parent
            }
          };
  return (
    <div>
      <label className="block mb-2 text-sm font-medium text-gray-600">Réassigner à :</label>
      <select
        className="w-full p-2 border rounded"
        value={selectedUser}
        onChange={handleChange}
      >
        <option value="">Sélectionner un utilisateur</option>
        {roles.map((role) => (
          <option key={role.userId} value={role.userId}>
            {role.nom} - {role.email}
          </option>
        ))}
      </select>
    </div>
  )
}

export default ReassignerGroup